export default __webpack_public_path__ + "atomic/_patterns/02-molecules/separate-content-block/_separate-content-block.twig";